var _Object$defineProperties = require("../core-js/object/define-properties");

var _Object$freeze = require("../core-js/object/freeze");

function _taggedTemplateLiteral(strings, raw) {
  return _Object$freeze(_Object$defineProperties(strings, {
    raw: {
      value: _Object$freeze(raw)
    }
  }));
}

module.exports = _taggedTemplateLiteral;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js
// module id = 123
// module chunks = 0 1